import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import StateService from "../../src/Services/State.service";
const StateLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<State[]>' is not assignable to type '(ids: string[]) => Promise<State[]>'.
        fetchItemsById: (ids) => {
            return StateService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return StateService.searchAll(search);
        },
        optionRenderer: function optionRenderer(state) {
            return _jsx("span", { children: state.name });
        },
    });
};
export default StateLookup;
